import React, { useState, useEffect, useRef } from 'react';
import { InputBox } from 'atoms/InputBox';
import ImageComponent from 'atoms/Image/index';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import MENUS_PLP_CONSTANTS from '../Constants/MenusPLPConstants';
import { setAnalyticsData } from '../MenusPlpUtilities/MenusPlpUtils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const MobSearchFilterMenu = React.forwardRef(
  (
    {
      className,
      filterList,
      dietaryList,
      sortByListMob,
      handleClearItems,
      closeSearchFilterMenu,
      handleFilteredData,
      handleSearchdata,
      setSearchModeData,
      data,
      inputSearchData,
    },
    ref,
  ) => {
    const [inputSearchOpen, setInputSearchOpen] = useState(false);
    const [suggestedData, setsuggestedData] = useState([]);
    const [inputSearchValue, setInputSearchValue] = useState('');
    const filterRef = useRef(null);
    const { SEARCHOURMENU } = MENUS_PLP_CONSTANTS;
    const handleClickOutside = event => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setInputSearchOpen(false);
      }
    };
    const { SearchIconGrey, CrossCloseIcon, ClearIconDark } = IMAGE_PATH;
    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });

    useEffect(() => {
      setInputSearchValue('');
      setInputSearchOpen(false);
    }, [inputSearchData]);

    const clearSearch = () => {
      setInputSearchValue('');
      handleSearchdata();
      setSearchModeData(false, '');
    };

    const handleInput = e => {
      setInputSearchValue(e.target.value);
      if (filterList.length || dietaryList.length || sortByListMob.length) {
        handleClearItems();
      }
      if (e.target.value.toString().length > 2) {
        if (!inputSearchOpen) {
          setInputSearchOpen(true);
          filteredMenu(e.target.value.toLowerCase().toString());
        }
      } else {
        if (inputSearchOpen) {
          setInputSearchOpen(false);
          handleSearchdata();
          filteredMenu('');
          setSearchModeData(false, inputSearchValue);
        }
      }
    };

    const filteredData = item => {
      // analytics event triggered
      setAnalyticsData(
        {
          eventType: 'suggestedSearchClick',
          selectedData: item.name,
        },
        'suggestedSearchTerm',
      );
      handleFilteredData(item.mdmId);
      closeSearchFilterMenu();
      setInputSearchValue(item.name);
      setSearchModeData(true, item.name);
      window.scrollTo(0, 0);
    };

    const handleKeyPress = event => {
      if (event.key === 'Enter') {
        closeSearchFilterMenu();
        handleSearchdata(event.target.value.toLowerCase().toString());
        setSearchModeData(true, inputSearchValue);
        window.scrollTo(0, 0);
      }
    };

    const filteredMenu = val => {
      const { products } = data || {};
      setsuggestedData(products.filter(obj => !obj.isHidden && obj.name.toLowerCase().indexOf(val) !== -1).slice(0, 5));
      window.scrollTo(0, 0);
    };
    return (
      <div ref={ref} data-testid='mob-search-filter-testid' className={className}>
        <div className='refineItemsPartMobPLP'>
          <span className='refineItemsText'>{translateWithI18Next('refineItems')}</span>
          <img
            className='crossCloseIconFilterMobPlp'
            data-testid='cross-close-filter-mob'
            onClick={() => closeSearchFilterMenu('Close')}
            src={CrossCloseIcon}
            alt='Cross Icon'
          />
        </div>
        <div className='searchInputMobMenuPlp'>
          <div className='plp-search-container'>
            <InputBox
              data-testid='mob-search-input'
              className='search-menu-inputMob'
              onChange={e => handleInput(e)}
              onKeyPress={e => handleKeyPress(e)}
              value={inputSearchValue}
              placeholder={translateWithI18Next(SEARCHOURMENU)}
            />
            <div className='search-iconMob'>
              <ImageComponent srcFile={SearchIconGrey} className='search-icon-img' />
            </div>
            {inputSearchValue.length > 2 && (
              <img
                data-testid='mob-cross-icon'
                className='input-dark-cross-mob'
                onClick={() => clearSearch()}
                src={ClearIconDark}
                alt='Clear Icon'
              />
            )}
          </div>

          {inputSearchOpen && (
            <div ref={filterRef} data-testid='mob-search-dropdown' className='inputAutoCompletePLP'>
              <ul className='autoCompleteListPLP'>
                {suggestedData?.length > 0 &&
                  suggestedData.map((item, index) => (
                    <li
                      onClick={() => filteredData(item)}
                      key={item.mdmId + index}
                      data-testid={`fiter-data-${item.name}`}
                      className='wrapperAutoCompletePLP'
                    >
                      <span className='searchgrey-icon-img'>
                        <ImageComponent srcFile={SearchIconGrey} />
                      </span>
                      <span>{item.dname?.[0]?.value}</span>
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default MobSearchFilterMenu;
